import { RetryLink } from "@apollo/client/link/retry";

/**
 * Reference: @link https://www.apollographql.com/docs/link/links/retry/
 */
export const retryLink: RetryLink = new RetryLink({
  delay: {
    initial: 500, // in ms
    jitter: true, // randomizes subsequent calls.
  },
  attempts: {
    max: 5,
  },
});
